import { InjectionToken } from "@angular/core";
import { MergePatient } from "../merge-patient";

export interface MergePatientsAction {
    merge(parent: MergePatient, child: MergePatient): void;
}

export const MergePatientAction = new InjectionToken<MergePatientsAction>("Merge Action");
